import React from "react";
import Hero from "../components/Hero";
import Feature from "../components/Feature";
import About from "../components/About";

const HomePage = () => {
  return (
    <div>
      <Hero />
      <Feature />
      <About />
    </div>
  );
};

export default HomePage;
